import React from "react";
import { useTranslation } from "react-i18next";
import { PMCustomSelector } from "../PMCustomSelector";
import { fetchUsers } from "../../../api/user";

export const EmployeeCustomSelector = ({
  label,
  selected,
  onChange,
  disabled = false,
  zIndex,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const fetchEmployees = React.useCallback(async () => {
    try {
      const response = await fetchUsers({
        filters: [{ name: "EMPLOYEE", value: true }],
        per_page: 100,
      });
      const users = response?.data?.data || response?.data || response || [];
      return (Array.isArray(users) ? users : []).map((user) => ({
        ...user,
        displayTitle: user.displayTitle || user.name || `User ${user.id}`,
      }));
    } catch (error) {
      console.error("Error fetching employees:", error);
      return [];
    }
  }, []);

  const selectedItem = React.useMemo(() => {
    if (!selected?.id) return null;
    return {
      ...selected,
      id: selected.id,
      displayTitle: selected.displayTitle || selected.name || `User ${selected.id}`,
    };
  }, [selected?.id, selected?.displayTitle, selected?.name, selected?.email]);

  const handleSelect = (item) => {
    const userObject = {
      id: item.id,
      displayTitle: item.displayTitle || item.name,
      email: item.email,
      mobile: item.mobile,
      department: item.department,
      ...item,
    };
    onChange?.(userObject.id, userObject);
    setIsOpen(false);
  };

  const handleClear = (event) => {
    event.stopPropagation();
    onChange?.(null, null);
  };

  return (
    <div>
      {label ? (
        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      ) : null}
      <div
        className={`cursor-pointer block w-full border border-gray-300 rounded-md bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 ${
          disabled ? "opacity-50 cursor-not-allowed" : "hover:border-gray-400"
        }`}
        onClick={() => !disabled && setIsOpen(true)}
      >
        {selectedItem ? (
          <div className="flex items-center justify-between gap-2">
            <span className="text-gray-900 truncate">
              {selectedItem.displayTitle}
            </span>
            {!disabled && (
              <div className="flex items-center gap-2 shrink-0">
                <button
                  type="button"
                  onClick={handleClear}
                  className="text-red-600 hover:text-red-800 text-xs"
                >
                  {t("Clear")}
                </button>
                <span className="text-indigo-600 text-xs">{t("Change")}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="text-gray-400">
            {t("meeting_minutes.entry.select_responsible")}
          </div>
        )}
      </div>
      {isOpen && (
        <PMCustomSelector
          open={isOpen}
          onClose={() => setIsOpen(false)}
          fetchFunction={fetchEmployees}
          onSelect={handleSelect}
          selected={selectedItem}
          field="displayTitle"
          field2="email"
          field3="mobile"
          title={t("meeting_minutes.entry.select_responsible")}
          description={t("meeting_minutes.entry.select_responsible")}
          showSearch={true}
          disabled={disabled}
          zIndex={zIndex}
        />
      )}
    </div>
  );
};
